export const helpManifest = [
  {
    slug: 'query-blueprints',
    title: 'Query Blueprints',
    children: [
      { slug: 'query-blueprints/overview', title: 'Query Blueprints' },
      { slug: 'query-blueprints/getting-started', title: 'Getting Started' },
      { slug: 'query-blueprints/purposes', title: 'Purposes' },
      { slug: 'query-blueprints/presentations', title: 'Presentation Types' },
      { slug: 'query-blueprints/latch-dates', title: 'Latch Dates' },
      { slug: 'query-blueprints/how-to-scope', title: 'How To: Scope Book of Business Views' },
      { slug: 'query-blueprints/how-to-client-filter', title: 'How To: Use the Client Filter' },
      { slug: 'query-blueprints/how-to-hierarchical-table', title: 'How To: Configure a Hierarchical Table' },
      { slug: 'query-blueprints/how-to-hierarchical-grid', title: 'How To: Configure a Hierarchical Grid' },
      { slug: 'query-blueprints/how-to-filtering', title: 'How To: Set Up Dynamic Filtering' },
      { slug: 'query-blueprints/how-to-chart', title: 'How To: Configure a Chart' },
      { slug: 'query-blueprints/how-to-metric', title: 'How To: Configure a Metric' }
    ]
  },
  {
    slug: 'system-tools',
    title: 'System Tools',
    children: [
      { slug: 'system-tools/format-strings', title: 'Format Strings' },
      { slug: 'system-tools/advanced-format-strings', title: 'Advanced Format Strings' }
    ]
  }
]

export const findArticle = (slug) => {
  for (const section of helpManifest) {
    if (section.slug === slug) return { title: section.title, slug: section.slug }
    const child = section.children?.find(c => c.slug === slug)
    if (child) return child
  }
  return null
}

export const getDefaultArticle = () => {
  const first = helpManifest[0]
  return first?.children?.[0] ?? first ?? null
}
